export const BARRIER_TYPES = ['Down-and-In', 'Down-and-Out', 'Up-and-In', 'Up-and-Out'] as const

export type BarrierType = (typeof BARRIER_TYPES)[number]

export const BARRIER_TYPE_LABELS: Record<BarrierType, string> = {
  'Down-and-In': 'Down-and-In',
  'Down-and-Out': 'Down-and-Out',
  'Up-and-In': 'Up-and-In',
  'Up-and-Out': 'Up-and-Out',
}

export const BARRIER_TYPE_OPTIONS = BARRIER_TYPES.map((b) => ({
  label: BARRIER_TYPE_LABELS[b],
  value: b,
}))
